var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeHide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34203 12.782L6.41103 12.264L7.19803 9.32499C6.01999 8.89051 4.92514 8.25735 3.96103 7.45299L1.80803 9.60699L0.393025 8.19199L2.54703 6.03898C1.3311 4.58274 0.514113 2.83575 0.176025 0.968985L2.14403 0.609985C2.90303 4.81199 6.57903 7.99999 11 7.99999C15.42 7.99999 19.097 4.81199 19.856 0.609985L21.824 0.967985C21.4864 2.835 20.6697 4.58235 19.454 6.03898L21.607 8.19199L20.192 9.60699L18.039 7.45299C17.0749 8.25735 15.9801 8.89051 14.802 9.32499L15.589 12.265L13.658 12.782L12.87 9.84199C11.6324 10.0541 10.3677 10.0541 9.13003 9.84199L8.34203 12.782Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye-hide.1725a5dc9ade27ac9cdbd43f91e5b46a.svg";
export { ForwardRef as ReactComponent };